/* monitoring: the dashboard, the monitoring page and one match under review —
 * translated in the Wave 3 pass (2026-09-30). Mirrors en/monitoring.ts. */
export default {
  dash: {
    subtitle: 'Какво откри наблюдението в портфолиото ви.',
    updated: 'последна проверка: {when}',
    addTrademark: 'Добави марка',
    kpi: {
      label: 'Обобщение на наблюдението',
      watched: 'Наблюдавани марки',
      watchedOf: 'от {total}',
      unwatched: '{n} без никакво наблюдение',
      matches: 'Открити съвпадения',
      highRisk: 'Съвпадения с висок риск',
      closeWithin: 'изтича до 14 дни | изтичат до 14 дни',
      nextWindow: 'Следващ срок: {when}',
    },
    recent: {
      title: 'Последни съвпадения',
      viewAll: 'Виж всички {n}',
      col: {
        detected: 'Открита',
        protected: 'Защитена',
        risk: 'Риск',
        registry: 'Регистър',
        classes: 'Класове',
        deadline: 'Срок',
        status: 'Състояние',
      },
    },
    deadlines: {
      title: 'Предстоящи срокове',
      badge: '{n} с висок риск до 14 дни',
      open: 'Отвори съвпадението',
      viewAll: 'Всички съвпадения по срок',
    },
    registryLastScan: '· последна проверка: {when}',
  },

  mon: {
    subtitle: {
      matched:
        'публикувана марка, съвпадаща с портфолиото ви | публикувани марки, съвпадащи с портфолиото ви',
      across: 'За',
      ofYours: 'от вашите марки',
      registries: '{n} регистър | {n} регистъра',
    },
    lastScan: 'Последна проверка: {when}',
    yours: 'Вашата марка',
    trademarks: '{n} марка | {n} марки',
    filters: 'Филтри',
    addToMonitoring: 'Добави за наблюдение',
    kpi: {
      label: 'Обобщение на съвпаденията',
      total: 'Общо открити съвпадения',
      judged: '{n} прочетени от AI съдията',
      highHint: 'За преглед · {n} със срок до 14 дни',
      medHint: 'Препоръчва се преглед',
      lowHint: 'Преглед, когато има време',
    },
    filter: {
      window: 'Може ли още да се действа?',
      windowOpen: 'Срокът още тече',
      windowUnknown: 'Няма публикуван срок',
      windowClosed: 'Срокът е изтекъл',
      windowAll: 'Покажи всички',
      risk: 'Риск',
      registry: 'Регистър',
      state: 'Състояние на прегледа',
    },
    state: {
      new: 'Чака преглед',
      reviewed: 'Прегледано',
      dismissed: 'Отхвърлено',
      escalated: 'Насочено към опозиция',
    },
    toolbar: {
      shown: '{n} показани',
      grouped: 'Групирани по вашата марка',
      sortLabel: 'Подредба',
      sort: 'Първо изтичащите срокове',
    },
    intro: {
      bands:
        'Всяка оцветена лента по-долу е една от вашите марки. Редовете под нея са марки от бюлетините на регистрите, които проверката е открила като възможен конфликт с нея.',
      openOnly:
        'Показани са само тези, чийто срок за опозиция още не е изтекъл — {link}, включително {n} с изтекъл срок.',
      showAll: 'покажи всички {n}',
    },
    thead: {
      detected: 'Открита марка',
      similarity: 'Анализ на сходството',
      riskDeadline: 'Риск и срок',
      actions: 'Действия',
    },
    band: {
      toggle: 'Покажи или скрий съвпаденията за {name}',
      countWord: 'съвпадение | съвпадения',
      reg: 'Рег. № {n}',
      active: 'Активно наблюдение',
      paused: 'Наблюдението е спряно',
      notScanned: 'Още не е проверявана',
    },
    logo: 'Лого на {name}',
    empty: 'Няма съвпадения в този изглед.',
    clearFilters: 'Изчистете филтрите',
    clearHint: '{link}, за да видите всички.',
    showing: 'Показани са {shown} от {total} съвпадения, първо изтичащите срокове.',
    row: {
      view: 'Подробности',
      dismiss: 'Отхвърли съвпадението',
    },
    dismissPrompt:
      'Защо „{name}“ не е конфликт?\n\nПричината се запазва към съвпадението. Никой модел не се преобучава с нея — с нея измерваме дали AI е бил прав и спрямо нея по-късно се настройват праговете.',
    rail: {
      label: 'Обобщение',
      found: 'Какво откри проверката',
      summary: 'Проверката откри {matches} спрямо портфолиото ви, от които {high} са с висок риск.',
      matches: '{n} съвпадение | {n} съвпадения',
      breakdown: 'Разпределение по риск',
      total: 'Всички съвпадения',
      decided: 'Как са решени',
      judged: 'Прочетени от AI съдията',
      judgedSub: 'Заключение с обосновка',
      rule: 'Съвпадение по правило',
      ruleSub: 'Идентични или почти идентични',
      awaiting: 'Чакат вашия преглед',
      awaitingSub: 'Още не са обработени',
    },
    health: {
      title: 'Състояние на наблюдението',
      summary: '{count} марки се наблюдават. Последна проверка: {when}.',
      count: '{n} от {total}',
      unwatched: 'Изобщо не се наблюдават',
      unwatchedSub: 'За тях не се проверява нито един регистър',
      registries: 'Наблюдавани регистри',
      workload: 'Натовареност',
      awaiting: 'Чакат решение',
      awaitingSub: 'Никой още не ги е разгледал',
      next: 'Следващ изтичащ срок',
      nextSub: 'Сред съвпаденията без отговор',
    },
    start: {
      title: 'Откъде да започнете',
      review: 'Първо прегледайте {high}.',
      high: '{n} съвпадение с висок риск | {n} съвпадения с висок риск',
      closingCount: '{n} от тях',
      closingTail: 'има срок за опозиция до 14 дни. | имат срок за опозиция до 14 дни.',
      button: 'Към съвпаденията с висок риск',
    },

    deadline: {
      today: 'Изтича днес',
      closedDays: 'Изтекъл преди {n} ден | Изтекъл преди {n} дни',
      closedMonths: 'Изтекъл преди {n} месец | Изтекъл преди {n} месеца',
      closedYears: 'Изтекъл преди {n} година | Изтекъл преди {n} години',
      on: 'Срок: {date}',
    },
    since: {
      never: 'никога',
      now: 'току-що',
      minutes: 'преди {n} мин',
      hours: 'преди {n} час | преди {n} часа',
      days: 'преди {n} ден | преди {n} дни',
    },
    tag: {
      filed: 'Заявена {date}',
      judge: 'AI съдия · {model}',
      judgeUnnamed: 'AI съдия',
      rule: 'По правило',
    },
    channel: {
      visual: 'Визуално',
      aural: 'Звучене',
      phonetic: 'Звучене',
      conceptual: 'Значение',
      name_semantic: 'Значение',
      goods: 'Стоки и услуги',
      name_trigram: 'Изписване',
      name_contains: 'Съдържа се',
      name_stem: 'Общ корен',
      name_edit: 'Близко изписване',
      logo_text: 'Думи в логото',
      logo_visual: 'Визия',
      logo_phash: 'Същото изображение',
      gate: 'Праг',
      rerank: 'Пресяване',
    },
    belt: {
      edit: '{a} и {b} се различават с {n} буква от {letters} | {a} и {b} се различават с {n} букви от {letters}',
      stemStart: 'И двете започват с {stem}',
      stemInside: 'И двете съдържат корена {stem}',
      stemCoverage: '{text}, което е {pct}% от думата',
      contains: '{inner} се съдържа в {outer}',
      sound: 'Двете наименования имат общ звуков ключ ({keys})',
      spelling: 'Изписването се припокрива (сходство {n})',
      meaning: 'Наименованията са близки по значение (сходство {n})',
      goods: 'Стоките и услугите са близки (сходство {n})',
      logoWords: 'В логата се срещат едни и същи думи: {words}',
      samePicture:
        'Изображенията са почти идентични (разлика {n} бит) | Изображенията са почти идентични (разлика {n} бита)',
      looksAlike: 'Изображенията си приличат (сходство {n})',
      rerank: 'Оценка от модела за пресяване: {score} ({band})',
      rerankBand: 'Модел за пресяване: {band}',
    },
    rerankBand: {
      floor: 'под прага',
      gray: 'сива зона',
      top: 'най-горна група',
      unscored: 'без оценка',
    },
    decision: {
      ceiling: 'Показано веднага',
      surface: 'Показано',
      gray: 'Сива зона',
      floor: 'Под долния праг',
      dismiss: 'Отхвърлено',
    },
    gate: {
      identical: 'идентично наименование',
      edits: 'наименование с разлика до {n} буква | наименование с разлика до {n} букви',
      sound: 'същото звучене при същата дължина',
      picture: 'същото изображение (разлика {n} бит) | същото изображение (разлика {n} бита)',
      floor: 'всички сигнали под {line}',
    },
    escalation: {
      notDismissed: 'Не е изпратено към втори модел: първият не е отхвърлил двойката',
      below: 'Не е изпратено към втори модел: оценка при пресяването {score}, под {line}',
      noSecond:
        'Не е изпратено към втори модел: оценка при пресяването {score} ≥ {line}, но нямаше наличен втори модел',
      escalated:
        'Изпратено към втори модел: първият отхвърли двойката, оценка при пресяването {score} ≥ {line}',
    },
    markType: {
      word: 'Словна марка',
      figurative: 'Фигуративна марка',
      combined: 'Комбинирана марка',
      sound: 'Звукова марка',
      other: 'Друга',
    },
    brandStatus: {
      registered: 'Регистрирана',
      pending: 'В процедура',
      filed: 'Заявена',
      published: 'Публикувана',
      opposed: 'С опозиция',
      cancellation_procedure: 'Производство по заличаване',
      expired: 'Изтекла',
      refused: 'Отказана',
      withdrawn: 'Оттеглена',
    },
    feedback: {
      confirm: 'Потвърден конфликт',
      escalate: 'Насочено към опозиция',
      dismiss: 'Отхвърлено',
      false_positive: 'Не е конфликт',
    },
  },

  match: {
    review: 'Преглед на съвпадение',
    title: '{found} срещу {ours}',
    subtitle: 'Вашата марка {ours} срещу публикация в {registry}: {found}',
    previous: 'Предишно',
    next: 'Следващо',
    close: 'Затвори',
    back: 'Обратно към наблюдението',
    yourMark: 'Вашата наблюдавана марка',
    position: 'Съвпадение {p} от {total}',
    viewTrademark: 'Към марката →',
    compare: 'Сравнение на марките',
    found: 'Открита в бюлетина',
    vs: 'срещу',
    field: {
      classes: 'Класове по Ница',
      registered: 'Регистрирана',
      applicationNo: '№ на заявката',
      type: 'Вид',
      filed: 'Заявена',
      registry: 'Регистър',
      name: 'Наименование',
      owner: 'Притежател',
      registrationNo: 'Рег. №',
      status: 'Статус',
      deadline: 'Срок за опозиция',
      vienna: 'Виенски кодове',
      designated: 'Посочени държави',
      found: 'Открито',
      reviewState: 'Състояние на прегледа',
    },
    nonePublished: 'Няма публикуван',
    score: {
      judge: 'Оценка на риска от AI',
      rules: 'Оценка по правилата',
      low: 'Нисък',
      med: 'Среден',
      high: 'Висок',
      window: 'Срок за опозиция',
      decidedBy: 'Решено от',
      matchingRules: 'правилата за съвпадение',
    },
    tab: {
      label: 'Раздели на прегледа',
      analysis: 'Защо е открито',
      details: 'Двете марки',
      timeline: 'Хронология',
    },
    analysis: {
      judge: 'Какво прочете AI',
      rules: 'Какво откриха правилата',
      judgeIntro:
        'Модел прочете двойката така, както би я прочел експерт, и даде четирите оценки по-долу. Това е мнение, не решение: целта му е да постави пред вас двойките, които заслужават времето ви.',
      rulesIntro:
        'Никой модел не е чел тази двойка. Тя е тук, защото са се задействали правилата за съвпадение по-долу — всяко от тях е проверка, която можете да направите и сами.',
      firstReading: 'Първо прочитане — {model}: {verdict}',
      surfaced: 'Показано веднага:',
      shared: 'Общи класове по Ница: {list}',
    },
    decide: {
      title: 'Вашето решение',
      intro:
        'Каквото и да решите, се запазва към съвпадението: така измерваме дали AI е бил прав и спрямо това по-късно се настройват праговете. Съгласието е с едно щракване. Несъгласието изисква причина, защото именно този отговор ни казва нещо ново.',
      already: 'Вече отговорено:',
      someone: 'Някой',
      disagreed: '· не е съгласен с машината',
      saving: 'Запазване…',
      confirm: 'Да, това е конфликт',
      escalate: 'Конфликт — за опозиция',
      orDismiss: 'Или посочете, че не е конфликт, и защо:',
      reasons: 'Причина за отхвърляне',
      own: 'Със свои думи',
      required: '(задължително)',
      optional: '(по желание)',
      placeholder:
        'напр. продават промишлен софтуер за нефт и газ — няма припокриване с нашия потребителски продукт, въпреки същия клас по Ница на хартия.',
      hint: 'Запазва се с решението ви. Свободният текст се пази до причината по-горе, а не вместо нея, защото списъкът може да се преброи, а прозата — не.',
      failed: 'Отговорът ви не беше запазен. Опитайте отново след малко.',
      dismiss: 'Не е конфликт — отхвърли',
    },
    reason: {
      different_market: {
        label: 'Различен отрасъл или пазар',
        sub: 'Реалната употреба не се припокрива',
      },
      weak_sound: {
        label: 'Слаба звукова връзка',
        sub: 'Изписването е надценено спрямо звученето',
      },
      not_confusable: {
        label: 'Няма вероятност от объркване',
        sub: 'Без правно значение на практика',
      },
      coexists: {
        label: 'Вече съжителстват',
        sub: 'Има предишно споразумение за съвместно съществуване',
      },
      visual_difference: {
        label: 'Преобладава визуалната разлика',
        sub: 'Логата или оформлението ясно се различават',
      },
      other: {
        label: 'Друго',
        sub: 'Обяснете със свои думи',
      },
    },
    details: {
      title: 'Марката, открита в бюлетина',
      goods: 'Стоки и услуги в общите ви класове',
    },
    timeline: {
      title: 'Какво се случи и кога',
      registered: '{name} е регистрирана',
      filed: '{name} е заявена',
      found: 'Открито при проверката',
      read: 'Прочетено от {model}',
      closes: 'Изтичане на срока за опозиция',
    },
    rail: {
      label: 'Обобщение на съвпадението',
      this: 'Това съвпадение',
      applicant: 'Същият заявител, другаде',
      applicantSummary: '{owner} има {filings}, съвпаднали с портфолиото ви.',
      sameApplicant: 'Същият заявител',
      otherFilings: '{n} друга заявка | {n} други заявки',
      against: 'срещу {brand}',
      filing: 'Тази заявка срещу другите ви марки',
      filingSummary: 'Същата заявка съвпадна и с {marks}.',
      otherMarks: '{n} друга ваша марка | {n} други ваши марки',
      othersAgainst: 'Други срещу {brand}',
      othersSummary:
        'Още {n} заявка е открита срещу тази марка. | Още {n} заявки са открити срещу тази марка.',
      rest: 'Прегледайте останалите',
      nextForBrand: 'Следващо съвпадение за тази марка',
      backAll: 'Към всички съвпадения',
    },
  },
} as const
